import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { AccountingCustomerContext } from '@/types/customer-context'

export async function readAccountingCustomerContext() {
  const response = await httpClient('accounting-dealer').get<AccountingCustomerContext>(
    '/v3/customer/context',
    { ignoreErrorToast: true },
  )

  return response.data
}

export function useAccountingCustomerContext() {
  return useQuery({
    queryKey: ['customer-context', 'accounting'],
    queryFn: readAccountingCustomerContext,
    retry: 1,
  })
}
